const SpinnerWrapper = ({ children }) => {
  return <div className="centering my-5 py-5">{children}</div>;
};

export default SpinnerWrapper;
